import { render, staticRenderFns } from "./service-request-posted.vue?vue&type=template&id=37381334&scoped=true"
import script from "./service-request-posted.vue?vue&type=script&lang=js"
export * from "./service-request-posted.vue?vue&type=script&lang=js"
import style0 from "./service-request-posted.vue?vue&type=style&index=0&id=37381334&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37381334",
  null
  
)

export default component.exports